import { Container, Typography } from "@mui/material";
import { NavigationAndFooterLayout } from "../layouts";
import { NextPageWithLayout } from "@cm-websites/common";
import { NextSeo } from "next-seo";
import React from "react";

export const VersandkostenPage: NextPageWithLayout = () => (
  <React.Fragment>
    <NextSeo title="Versandkosten & Lieferzeiten | Culinario Mortale®" noindex />
    <Container
      maxWidth="md"
      sx={{ pt: { xs: 12, sm: 14, lg: 16 }, pb: { xs: 8, sm: 10, lg: 14, xl: 16 } }}
    >
      <Typography variant="h1" sx={{ pb: 6 }}>
        Versandkosten & Lieferzeiten
      </Typography>
      <Typography variant="body1" paragraph>
        Alle auf unserer Webseite angezeigten Preise verstehen sich inklusive der gesetzlichen
        Mehrwertsteuer.
      </Typography>
      <Typography variant="body1" paragraph>
        Der Versand von Bestellungen mit einer Lieferadresse innerhalb Deutschlands erfolgt
        versandkostenfrei. Die Lieferzeit beträgt in diesem Fall 3 – 5 Werktage.
      </Typography>
      <Typography variant="body1" paragraph>
        Für Bestellungen mit einer Lieferadresse außerhalb Deutschlands erheben wir eine
        Versandkostenpauschale in Höhe von 4,50 €. Die Lieferzeit für Bestellungen mit einer
        Lieferadresse außerhalb Deutschlands beträgt abweichend 9 Werktage.
      </Typography>
      <Typography variant="body1" paragraph>
        Für Lieferungen in die Schweiz können bei der Einfuhr zusätzlich Mehrwertsteuer, Zölle oder
        andere Abgaben wie Verzollungskosten anfallen. Diese Kosten sind nicht in den Waren- oder
        Versandkosten enthalten und sind vom Kunden bei der Einfuhr an Dritte zu entrichten.
      </Typography>
    </Container>
  </React.Fragment>
);

VersandkostenPage.getLayout = (page) => <NavigationAndFooterLayout>{page}</NavigationAndFooterLayout>;

export default VersandkostenPage;
